import { MenuKeys } from "../../menus/menu-keys";
import { ControllerContext } from "../controller";

export const preStartMenuContext: ControllerContext = {
  start: {
    onDown: (_e, ctx) => {
      ctx.menuManager.closeMenu(MenuKeys.PreStartMenu);
      ctx.controller.popContext();
    },
  },
  actionA: {
    onDown: (_e, ctx) => {
      ctx.menuManager.activate(ctx);
    },
  },
  actionB: {
    onDown: (_e, ctx) => {
      ctx.menuManager.closeMenu(MenuKeys.PreStartMenu);
      ctx.controller.popContext();
    },
  },
  up: {
    onDown: (_e, ctx) => {
      ctx.menuManager.up();
    },
  },
  down: {
    onDown: (_e, ctx) => {
      ctx.menuManager.down();
    },
  },
};
